const B2BSF = {
    ready:false, 
    customer_seleccionado:false,
    tarifa_seleccionada:false, 
    myCart: false,  
    shopify_cart:false,
    acc_url:  'https://puigmetal.es/customapp/b2bsf.0.00.php',// 'https://alucomponentes.blacklabelapp.io/b2bsf.0.00.php',
    is_cart_page: false,
    init:function(is_cart_page=false){
        console.log("B2BSF.init() PUIGMETAL"); 

        this.tarifa_seleccionada = 'Tienda' //TODO: obtener tarifa seleccionada del cliente

        const realLog = console.log;

            Object.defineProperty(console, 'log', {
            get() {
                return realLog;
            },
            set() {
                // Ignorar sobrescrituras  
                return true;
            }
            });


        //this.customer_seleccionado = this.customer.get_local()
        this.tarifa_seleccionada = this.tarifa.get_local()
        this.is_cart_page = is_cart_page
        B2BSF.cart.init(B2BSF.is_cart_page);

            this.bindEvents();




    },

    bindEvents:function(){ 
        console.log("B2BSF.bindEvents()");  

        
        $('#BTN_AddToCartB2B').on("click", function(e){
            e.preventDefault()
            console.log('in_variant_selected', $('#in_variant_selected').val() )
        })


        /*
        $(document).on('click','#btn_B2BSF_cambiar_cliente',function(e){
            e.preventDefault()
            B2BSF.customer_form.init()
            $('#form_buscar_cliente').show() 
        })
 

    
        */
    },
    action: (data, callback)=> {
 
        console.log('[B2BSF][ACC] >>>> ', data ) 
        var params = {
            type: 'POST',
            url:  B2BSF.acc_url,
            data: data, 
            dataType: 'json',
            success: function(rdata) {
                console.log('[DEVOS][ACC] <<<<<<< ', rdata )
                if ((typeof callback) === 'function') {
                    callback(rdata);
                }
            },
            error: function(XMLHttpRequest, textStatus) {
                console.log('ERROR---<<<<<<', data, XMLHttpRequest)  
            }
        };
        $.ajax(params);
    },
     customer:{
        get_local:function(){
            const B2BSF_CUSTOMER_SEL = window.localStorage.getItem('B2BSF_CUSTOMER_SEL')  
            if( B2BSF_CUSTOMER_SEL ){
              return JSON.parse(B2BSF_CUSTOMER_SEL)
            } else {
              return false
            } 
        },
        save_local:function(B2BSF_CUSTOMER_SEL){
            return window.localStorage.setItem('B2BSF_CUSTOMER_SEL', JSON.stringify(B2BSF_CUSTOMER_SEL) ) 
        },
        remove_local:function(){
            return window.localStorage.removeItem('B2BSF_CUSTOMER_SEL') 
        }
    },
    tarifa:{
        get_local:function(){
            const B2BSF_TARIFA = window.localStorage.getItem('B2BSF_TARIFA')  
            if( B2BSF_TARIFA ){
              return B2BSF_TARIFA 
            } else {
              return B2BSF.tarifa_default
            } 
        },
        save_local:function(B2BSF_TARIFA){
            return window.localStorage.setItem('B2BSF_TARIFA', B2BSF_TARIFA ) 
        },
        remove_local:function(){
            return window.localStorage.removeItem('B2BSF_TARIFA') 
        },
    },

}



function isB2BCustomer() {
  return document.body.classList.contains('customer-b2b');
}
 
  
$('#BTN_AddToCartB2B').on("click", function(e){
    e.preventDefault()
    console.log('in_variant_selected', $('#in_variant_selected').val() )
})
